<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      showEdit
      @edit='openEdit'
    >
      <v-card-text>
        <span v-if='!project.invoicing_notes'>None...</span>
        <span>{{ project.invoicing_notes }}</span>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      :showDialog='showDialog'
      @cancel='showDialog = false'
      @save='saveChanges'
    >
      <v-textarea outlined auto-grow v-model='projectCopy.invoicing_notes'></v-textarea>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'customer-instrucions',
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    title: 'Invoicing Notes',
    icon: 'mdi-currency-usd',
    iconColor: 'success',
    projectCopy: {},
    showDialog: false
  }),
  methods: {
    openEdit () {
      this.projectCopy = _.cloneDeep(this.project)
      this.showDialog = true
    },
    saveChanges () {
      this.$emit('update', this.projectCopy)
      this.showDialog = false
    }
  }
}
</script>
